import React, { FC, useCallback } from 'react';

import { Button } from '../../../button';
import { Modal } from '../../../modal/modal.component';
import { ModalIds } from '../../../../contexts/modals/modals.types';
import { Typography } from '../../../../../../../components';
import styles from './mail-server-success-modal.module.scss';
import { useModalsContext } from '../../../../contexts';
import { useTranslation } from 'react-i18next';

/**
 * MailServerSuccess component
 * @description Content for the MailServerSuccess window
 *
 * @author Ihor Dubas, Oleksii Medvediev
 * @category Components
 */
const MailServerSuccessModal: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });
  const { dispatch } = useModalsContext();

  const closeModal = useCallback(() => {
    dispatch({ type: 'HIDE_MODAL', payload: ModalIds.mailServerSuccess });
  }, [dispatch]);

  return (
    <Modal modalId={ModalIds.mailServerSuccess} title={t('modals.settingsMailServerSuccess.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>{t('modals.settingsMailServerSuccess.description')}</Typography.Text>
        <Button className={styles.closeBtn} size="large" onClick={closeModal}>
          <Typography.Text variant={'bodyText2'}>{t('modals.settingsMailServerSuccess.button')}</Typography.Text>
        </Button>
      </div>
    </Modal>
  );
};

export { MailServerSuccessModal };
